// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"AngledHeroHeader-df71b97be21ec338","slant":"AngledHeroHeader-eefd65987d61f50b","content":"AngledHeroHeader-52d11ee6b10495f5"};